<div class="container bg-gray p-3 rounded" *ngIf="cliente">

    <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
        <div class="row">
            <div class="px-2 text-center">
                <div class="alert alert-warning text-center" *ngIf="status == 'loading'">
                    <div class="spinner-border text-primary text-center" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div class="alert alert-success" *ngIf="status == 'succes'">Cliente agregado correctamente</div>
                <div class="alert alert-danger" *ngIf="status == 'failed'">El cliente no se ha podido agregar</div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4 col-xs-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label class="w-100">Nombre</mat-label>
                    <input matInput class="w-100" type="text" formControlName="nombre">
                </mat-form-field>
            </div>
            <div class="col-md-8 col-xs-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label class="w-100">Teléfono</mat-label>
                    <input matInput type="text" formControlName="telefono">
                </mat-form-field>
            </div>
        </div>

        <mat-form-field class="w-100 example-full-width" appearance="fill">
            <mat-label>Dirección</mat-label>
            <textarea matInput formControlName="direccion"></textarea>
        </mat-form-field>

        <input type="submit" class="btn btn-warning col-md-12 mt-4" value="Agregar cliente" name="" id=""
            [disabled]="form.invalid" />
    </form>
</div>